/**
 * The cart as the API serves it and the browser reads it. Every amount is in
 * whole cents of the shop's one currency, VAT included.
 */
import { z } from "zod";
import { ProductId } from "./catalog.js";
/** How many of one product a cart line holds. */
export const Quantity = {
    MIN: 1,
    MAX: 99,
    schema: z
        .number({ error: "Enter a quantity." })
        .int("Enter a whole number.")
        .min(1, "Enter at least 1.")
        .max(99, "You can order at most 99 of one item."),
};
export const AddToCartInput = {
    schema: z.strictObject({
        productId: ProductId.schema,
        quantity: Quantity.schema.default(1),
    }),
};
export const SetQuantityInput = {
    schema: z.strictObject({ quantity: Quantity.schema }),
};
//# sourceMappingURL=cart.js.map